<template>
  <div>
    <!-- Linha 1: Estatísticas Afiliados -->
    <h5 class="mb-2">Resumo geral</h5>
    <b-row class="mb-3">
      <b-col md="3" sm="6" v-for="(stat, index) in estatisticasAfiliado" :key="'stat-afil-'+index">
        <b-card class="text-center shadow-sm border-0 h-80">
          <div class="d-flex align-items-center">
            <div class="mr-3">
              <div :class="`rounded-circle p-2 bg-light-${stat.color}`">
                <feather-icon :icon="stat.icon" :class="`text-${stat.color}`" size="18"/>
              </div>
            </div>
            <div>
              <p class="card-text small text-muted mb-0">{{ stat.title }}</p>
              <h5 class="font-weight-bolder mb-0">{{ stat.value }}</h5>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Linha 2: Gráfico Comissões -->
    <b-row class="mb-4">
      <b-col lg="12">
        <!-- Card Comissões Mensais -->
        <b-card
          no-body
          class="shadow-sm border-0 h-40 mb-4"
        >
          <b-card-header class="d-flex justify-content-between align-items-center pb-0">
            <b-card-title>Comissões Mensais</b-card-title>
            <a
              href="#"
              class="chart-link small"
            >Este Ano</a>
          </b-card-header>
          <b-card-body>
            <line-chart
              :chart-data="chartDataComissoes"
              :options="chartOptionsComissoes"
              :height="150"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Linha 3: Dicas para Aumentar sua Rede -->
    <b-row class="mb-4">
      <b-col
        v-for="dica in dicasRede"
        :key="dica.id"
        lg="6"
      >
        <div class="modern-card h-100">
          <div class="card-gradient-header">
            <div class="card-icon-wrapper">
              <feather-icon
                :icon="dica.icon"
                size="20"
                class="text-white"
              />
            </div>
            <h6 class="card-title-modern mb-0 text-white">
              {{ dica.titulo }}
            </h6>
          </div>
          <div class="card-body-modern">
            <p class="card-description mb-3">
              {{ dica.texto }}
            </p>
            <div
              class="action-area"
              @click="handleDicaClick(dica)"
            >
              <div class="action-button">
                <feather-icon
                  icon="ArrowRightIcon"
                  size="16"
                  class="mr-2"
                />
                <span>Explorar</span>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Modal de Convite -->
    <b-modal
      id="modal-convite"
      title="Links de Convite"
      hide-footer
      size="md"
      centered
      body-class="p-0"
    >
      <div class="p-4">
        <div class="text-center mb-4">
          <div class="d-inline-flex align-items-center justify-content-center bg-light-primary rounded-circle mb-3" style="width: 60px; height: 60px;">
            <feather-icon icon="UserPlusIcon" size="24" class="text-primary" />
          </div>
          <h5 class="mb-1">Convidar Novos Usuários</h5>
          <p class="text-muted mb-0">Compartilhe os links abaixo para convidar novos membros</p>
        </div>

        <div class="space-y-3">
          <b-card class="border-0 shadow-sm mb-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center bg-light-success rounded-circle mr-3" style="width: 40px; height: 40px;">
                  <feather-icon icon="TrendingUpIcon" size="18" class="text-success" />
                </div>
                <div>
                  <h6 class="mb-0">Convite para Afiliado</h6>
                  <small class="text-muted">Link para cadastro de afiliados</small>
                </div>
              </div>
              <b-button 
                variant="outline-success" 
                size="sm" 
                @click="copyToClipboard(linkAfiliado)"
                class="d-flex align-items-center"
              >
                <feather-icon icon="CopyIcon" size="14" class="mr-1" />
                Copiar
              </b-button>
            </div>
          </b-card>

          <b-card class="border-0 shadow-sm mb-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center bg-light-info rounded-circle mr-3" style="width: 40px; height: 40px;">
                  <feather-icon icon="ShoppingBagIcon" size="18" class="text-info" />
                </div>
                <div>
                  <h6 class="mb-0">Convite para Vendedor</h6>
                  <small class="text-muted">Link para cadastro de vendedores</small>
                </div>
              </div>
              <b-button 
                variant="outline-info" 
                size="sm" 
                @click="copyToClipboard(linkVendedor)"
                class="d-flex align-items-center"
              >
                <feather-icon icon="CopyIcon" size="14" class="mr-1" />
                Copiar
              </b-button>
            </div>
          </b-card>
        </div>

        <div class="text-center">
          <b-button 
            variant="secondary" 
            @click="$bvModal.hide('modal-convite')"
            class="px-4"
          >
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardHeader, BCardTitle, BButton, BModal } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { Line } from 'vue-chartjs'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import { ref, onMounted, getCurrentInstance } from '@vue/composition-api'
import useDashboardPadrinho from '@/composables/useDashboardPadrinho'

// Componente de gráfico de linha personalizado
const LineChart = {
  extends: Line,
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$data._chart.destroy()
        this.renderChart(this.chartData, this.options)
      }
    }
  }
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BButton,
    BModal,
    FeatherIcon,
    LineChart,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const userData = getUserData()
    
    // Registrar módulo do store se não existir
    const USER_APP_STORE_MODULE_NAME = 'app-adm-usuario'
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      console.warn('Módulo app-adm-usuario não encontrado no store')
    }
    
    // Usar o composable do dashboard padrinho
    const {
      isLoading,
      estatisticasPadrinho,
      usuariosResumo,
      ultimasComissoes,
      proximoPagamentoPadrinho,
      chartDataComissoesPadrinho,
      chartDataDesempenhoVendedores,
      chartOptionsComissoesPadrinho,
      chartOptionsDesempenhoVendedores,
      dicasRede,
    } = useDashboardPadrinho()
    
    const linkAfiliado = ref('')
    const linkVendedor = ref('')

    const showConviteModal = async () => {
      try {
        const mode = process.env.MODE_APP || process.env.VUE_APP_MODE_APP
        const baseUrl = mode === 'prod'
          ? 'https://admin.avmarket.com.br'
          : 'https://admin.hml.avmarket.com.br'

        linkAfiliado.value = `${baseUrl}/register?code=${userData.padrinho.codigo}&group=4`
        linkVendedor.value = `${baseUrl}/register?code=${userData.padrinho.codigo}&group=5`
        proxy.$bvModal.show('modal-convite')
      } catch (error) {
        console.error('Erro ao buscar padrinho:', error)
      }
    }

    const copyToClipboard = text => {
      navigator.clipboard.writeText(text).then(() => {
        proxy.$bvToast.toast('Link copiado!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      }).catch(err => {
        console.error('Erro ao copiar o texto: ', err)
      })
    }

    const handleDicaClick = dica => {
      if (dica.id === 1) { // Compartilhe seu link de indicação
        showConviteModal()
      } else if (dica.id === 2) { // Acompanhe seus indicados
        proxy.$router.push({ name: 'app-admin-apadrinhados' })
      }
    }

    return {
      // Dados do composable
      isLoading,
      estatisticasAfiliado: estatisticasPadrinho,
      chartDataComissoes: chartDataComissoesPadrinho,
      chartDataCliques: chartDataDesempenhoVendedores,
      chartOptionsComissoes: chartOptionsComissoesPadrinho,
      chartOptionsCliques: chartOptionsDesempenhoVendedores,
      dicasRede,
      usuariosResumo,
      ultimasComissoes,
      proximoPagamento: proximoPagamentoPadrinho,
      
      // Funcionalidades do modal
      linkAfiliado,
      linkVendedor,
      showConviteModal,
      copyToClipboard,
      handleDicaClick,
    }
  },
}
</script>

<style scoped>
.chart-link {
  color: #6e6b7b;
  text-decoration: none;
}
.chart-link:hover {
  color: #5e5873;
}
.card-text {
  line-height: 1.2;
}
.h-100 {
  height: 100% !important;
}
.mb-3 {
  margin-bottom: 1rem !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
/* Ajustes para o alerta */
.alert.alert-light-primary {
  background-color: rgba(115, 103, 240, 0.12);
  border-color: rgba(115, 103, 240, 0.2);
  color: #7367f0;
}
.alert-heading {
  color: inherit;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.help-item {
  transition: transform 0.2s ease-in-out;
}
.help-item:hover {
  transform: translateY(-2px);
  cursor: pointer; /* Indica que é clicável */
}
.bg-light-primary { background-color: rgba(115, 103, 240, 0.1) !important; }
.text-primary { color: #7367f0 !important; }
.bg-light-success { background-color: rgba(40, 199, 111, 0.1) !important; }
.text-success { color: #28c76f !important; }
.bg-light-info { background-color: rgba(0, 207, 232, 0.1) !important; } /* Roxo claro/Info */
.text-info { color: #00cfe8 !important; } /* Roxo claro/Info */

/* Modern Card Styles */
.modern-card {
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
}

.modern-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.card-gradient-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 20px 20px;
  position: relative;
  display: flex;
  align-items: center;
}

.card-gradient-header::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0 0 50% 50%;
}

.card-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 10px;
  margin-right: 16px;
  backdrop-filter: blur(10px);
}

.card-title-modern {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.card-body-modern {
  padding: 24px 20px 20px;
  position: relative;
  z-index: 2;
}

.card-description {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.action-area {
  cursor: pointer;
  border-radius: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.action-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.action-area:hover::before {
  left: 100%;
}

.action-area:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  transform: scale(1.02);
}

.action-area:hover .action-button {
  color: white;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: #667eea;
  transition: color 0.3s ease;
  position: relative;
  z-index: 2;
}
</style>